module.exports = __webpack_public_path__ + "public/img/p11.d50bafd8.png";